<template>
  <div class="page-wrapper">

    <div v-show="payShop" class="pay-shop">
      <a :href="payShopUrl" target="_blank" class="pay-shop recommend"></a>
    </div>

    <div class="head-content">
      <div class="left-btn" @click="leftBtnClick()"></div>

      <div class="carousel-wrapper">
        <div class="swiper-container" id="head-swiper">
          <div class="swiper-wrapper">
            <div v-for="(item,index) in headPic" :key="index" class="swiper-slide">
              <img class="img" :src="item" />
            </div>
          </div>
        </div>

        <div class="swiper-pagination" id="head-swiper-pagination"></div>
      </div>

      <div class="right-btn" @click="rightBtnClick()"></div>
    </div>

    <div class="title-content title-content-1"></div>
    <div class="download">
      <ul class="download-content">
        <li class="d-icon"><a href="http://cdn.th.shankmgame.xyz/apk/shankm-th-official.apk" class="li-icon a-skm" @click="reportApk()"></a></li>
        <li class="d-download-skm">
          <el-popover
            placement="top"
            popper-class="popperDownload"
            trigger="click">
            <img class="popperImg" src="~src/assets/skm_qr_code.png">
            <a slot="reference" class="li-download a-skm-d" @click="reportApk()"></a>
          </el-popover>
          <!-- <a href="https://apps.apple.com/us/app/shan-koe-mee/id1486305282" class="iphone-d" @click="reportApk()"></a> -->
        </li>
        <li class="d-icon m-80"><a href="https://apps.apple.com/us/app/shan-koe-mee/id1486305282" class="li-icon a-sm" @click="reportApk()"></a></li>
        <li class="d-download">
          <!-- <el-popover
            placement="top"
            popper-class="popperDownload"
            trigger="click">
            <img class="popperImg" src="~src/assets/sm_qr_code.png">
            <a slot="reference" class="li-download a-sm-d" @click="reportApk()"></a>
          </el-popover> -->
          <a href="https://apps.apple.com/us/app/shan-koe-mee/id1486305282" class="iphone-d" @click="reportApk()"></a>
        </li>
      </ul>
    </div>

    <div class="title-content title-content-2"></div>
    <div class="record">
      <vueSeamless :data="listData" :class-option="classOption" class="seamless-warp">
          <ul class="roll-ul">
              <li v-for="(item,index) in listData" :key="index" class="roll-li">
                <span class="roll-title" v-text="item.title"></span>
                <span class="roll-date" v-text="item.date"></span>
              </li>
          </ul>
      </vueSeamless>
    </div>

    <div class="title-content title-content-3"></div>
    <div class="video-center">
      <video class="video-center video" :src="videoUrl" autoplay loop="loop" controls controlslist="nodownload"></video>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import vueSeamless from "vue-seamless-scroll"
import Swiper from "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "page",
  components: {
    vueSeamless
  },
  data() {
    return {
      videoUrl: '',
      headPic: [],
      listData: [],
      payShop: false,
    };
  },

  created() {
    //在窗口滚动时调用监听窗口滚动方法
    window.addEventListener('scroll', this.windowScrollListener);
    this.getRecord()
  },

  mounted() {
    //this.request_pic();
    this.get_banner();
  },

  destroyed() {
    //离开页面时删除该监听
    window.removeEventListener('scroll', this.windowScrollListener)
  },

  methods: {
    get_banner(){
      axios
        .get( this.$store.state.webHost + "offcial/getBanner", {
          params: {
            game: "shankm",
            num: "995192594",
            sig: "fa3e51df37ab908b08bfc1853ee4c289",
          },
        })
        .then((response) => {
          const data = response.data;
          if(0 === data.ret){
            this.headPic = []
            for(const i in data.pcPic){
              this.headPic.push(data.pcPic[i])
            }
            this.videoUrl = this.$store.state.webHostCdn + data.videoUrl
            this.$nextTick(() => {
              this.initSwiper();
            });
          }
        }).catch(function () {});
    },
    //监听窗口滚动
    windowScrollListener() {
      //获取操作元素最顶端到页面顶端的垂直距离 
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      var height = document.body.clientHeight || document.documentElement.clientHeight;
      let num = height*0.25
      if (scrollTop >= num) {
        this.payShop = true; //大于num时显示元素
      }
      if (scrollTop < num) {
        this.payShop = false; //小于num时隐藏元素
      }
    },

    getRecord(){
      this.listData = []
      for (var i=1;i<100;i++){
        const tmp = {}
        tmp.title = 'ဂုဏ္ယူပါတယ္။ \xa0\xa0\xa0' + this.functionJs.mathRandom(6) + '\xa0\xa0\xa0' + this.functionJs.randomPrize() + '\xa0\xa0\xa0 လဲၿပီးၿပီ။'
        tmp.date = ' -------------------- \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + this.functionJs.randomDate(i)
        this.listData.unshift(tmp)
      }
    },
    initSwiper() {
      this.headSwiper = new Swiper("#head-swiper", {
        loop: true,
        autoplay: {
          //delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        observer:true,
        observeParents:true,
        pagination: {
          el: "#head-swiper-pagination",
          clickable: true,
          bulletClass: "head-swiper-pagination-bullet",
          bulletActiveClass: "head-swiper-pagination-bullet-active"
        }
      });
    },
    leftBtnClick() {
      this.headSwiper.slidePrev();
    },
    rightBtnClick() {
      this.headSwiper.slideNext();
    },

    reportApk() {
      this.logJs.report("apkClick");
    }
  },
  computed: {
    classOption () {
      return {
        direction: 0,
        step: 0.4,
        openTouch: false
        // limitMoveNum: 1,
      }
    },
    payShopUrl() {
      return this.$store.state.payShopUrl;
    },
  }
};
</script>

<style lang="less">
@import "~src/styles/Normalize";
@import "~src/styles/index";
@import "~src/styles/pc/MainPage";
</style>
